export default __webpack_public_path__ + "static/media/ic-blocks.5e33b0ad.svg";